import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { UserInfoService } from '@wlp/ui-bs-login';
import { TokenCodeService } from '@wlp/ui-bs-token';
import { interval } from 'rxjs';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import * as moment from 'moment';
import {environment} from '../../../../../../../environments/environment';
import { StorageService, PrepareToCryptoService } from '@wlp/ui-bs-oauth';
import { SpeNAccounts } from '@wlp/ui-bs-dashboard';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-device-veracity',
  templateUrl: './device-veracity.page.html',
  styleUrls: ['./device-veracity.page.scss'],
})
export class DeviceVeracityPage implements OnInit {
  public navigationBackground: any;
  public brand: any;
  public userProfile: any;
  public loadCode: boolean;
  public qrData: any;
  public data: string;
  public progressbarValue: number;
  public sub: any;
  public verifySub: any;
  public codeOperation: string = "";
  public navigation: any;
  public state: any;
  private timeInterval = 10000;
  private intervalId: any;
  private initValidate: Date;
  private threeMinutes: Date;
  private uuidAccountPayment: string;
  private validatedChecksum: boolean = false;

  public formToken: FormGroup;
  public errorMessages: any;
  public errorToken: string;
  public loading = false;

  public isProdVersion = false;
  private readonly OPERATION_ACCESS_WEB: string = '61002';

  constructor(
    private layoutConfigService: LayoutConfigService,
    private tokenCodeService: TokenCodeService,
    protected userInfoService: UserInfoService,
    private nabvControler: NavController,
    private storageService: StorageService,
    private router: Router,
    private speNAccounts: SpeNAccounts,
    private prepareToCryptoService: PrepareToCryptoService,
    private cdr: ChangeDetectorRef,
  ) {
    this.errorMessages = this.tokenCodeService.getFormMessageError();
    this.formToken = this.tokenCodeService.createFormToken();
    this.isProdVersion = environment.production;
  }

  public ngOnInit() {
    this.brand = this.layoutConfigService.getConfig('wlTheme.timeline.brand.logo');
    this.navigationBackground = this.layoutConfigService.getConfig('wlTheme.intro.background.image');
    this.loadUser();
    this.navigation = this.router.getCurrentNavigation();
    this.state = this.navigation.extras.state as { checkSum: string };

    this.manipulateTimeValidation();
    this.startInterval();
  }

  public loadUser() {
    try {
      this.userInfoService.getInfoProfile().then((user) => {
        this.userProfile = user;
        this.generateQrcodeCodeToken();
        this.uuidAccountPayment = user.uuidAccount
      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  public generateQrcodeCodeToken() {
    try {
      // this.tokenCodeService.generateQrcodeCodeToken(this.userProfile.uuidWhiteLabel,
      //   this.userProfile.uuidAccount,
      //   this.OPERATION_ACCESS_WEB)
      //   .subscribe((res) => {
      //     this.loadCode = false;
      //     this.qrData = res;
      //     this.data = this.dataToString(res);
      //     this.resetSub();
      //     this.resetQrCode();
      //   });

       console.log('generateQrcodeCodeToken: checkSum::', this.state.checkSum);
       this.loadCode = false;
       this.qrData = {checkSum: this.state.checkSum};
       this.data = JSON.stringify({checkSum: this.state.checkSum});
    } catch (error) {
      console.log('generateQrcodeCodeToken error: ', error);
    }
  }

  public dataToString(res: any) {
    const aux = {checkSum: this.state.checkSum, res};
    return JSON.stringify(aux);
  }

  public resetQrCode() {
    this.progressbarValue = 1;

    this.sub = interval(1500)
      .subscribe((sec) => {
        this.progressbarValue = 1 - (sec * 20) / 1200;

        if (sec > 0 && sec % 5 === 0) {
          this.verifyQrcode();
        }

        if (this.progressbarValue === 0) {
          this.loadCode = true;
          this.sub.unsubscribe();
          this.verifySub.unsubscribe();
          this.generateQrcodeCodeToken();
          this.resetQrCode();
        }
      });
  }

  public resetSub() {
    if (this.sub !== undefined) {
      this.sub.unsubscribe();
    }
  }

  public verifyQrcode() {
    this.verifySub = this.tokenCodeService.verifyQrcode(this.qrData.res).subscribe((res: any) => {
      this.verifySub.unsubscribe();
      if (res.isUsed && this.validatedChecksum) {
        this.resetSub();
        // TODO: Adicionar armazenamento de check
        const dateExpired = moment(new Date()).add(30, 'minutes').toISOString();

        this.storageService.set(environment.keyStorage.accessWeb, 'true', true, dateExpired);
        this.nabvControler.navigateRoot('/app/dashboard');
      }
    });
  }

  private manipulateTimeValidation() {
    this.initValidate = new Date();
    const min = this.initValidate.getMinutes() + 3;
    this.threeMinutes = this.initValidate;
    this.threeMinutes = new Date(this.threeMinutes.setMinutes(min));
  }

  public async confirm() {
    this.loading = true;
    this.errorToken = '';

    const token = this.formToken.get('token').value;
    const validToken = await this.tokenCodeService.confirmToken(
      this.userProfile.uuidWhiteLabel,
      this.userProfile.uuidAccount,
      token,
    );

    if (validToken) {
      this.loading = false;

      const dateExpired = moment(new Date()).add(60, 'minutes').toISOString();

      console.log('inserindo registro de sessao web: ', environment.keyStorage.accessWeb, 'true', true, dateExpired);
      this.storageService.set(environment.keyStorage.accessWeb, 'true', true, dateExpired);
      this.nabvControler.navigateRoot('/app/dashboard');
    } else {
      this.loading = false;
      this.errorToken = 'CASH_OUT.MODAL_TOKEN.INVALID';
    }

    this.cdr.detectChanges();
  }

  private startInterval(): void {
    this.intervalId = setInterval(() => {
      this.validateChecksum(this.intervalId);
    }, this.timeInterval);
  }

  private async validateChecksum(intervalId: number) {
    const jwePub = await this.storageService.get(`${environment.jwe.pb}`, true);

    this.speNAccounts.certificateCheck( JSON.stringify( {checkSum: this.state.checkSum, certificate: jwePub}), this.uuidAccountPayment).subscribe(
      validationRes => {
        if (validationRes.accepted) {
          console.log(validationRes.accepted);
          this.calculateAndSaveChecksumPbcKey(validationRes.certificate);
          this.validatedChecksum = validationRes.accepted;
          clearInterval(intervalId);
          const dateExpired = moment(new Date()).add(30, 'minutes').toISOString();
          this.storageService.set(environment.keyStorage.accessWeb, 'true', true, dateExpired);
          this.nabvControler.navigateRoot('/app/dashboard');
        }
      },
      error => console.log(error)
    )
    
    const executionTime = new Date();
    if (executionTime > this.threeMinutes) {
      clearInterval(intervalId);
      this.onLogout();
    }
  }

  private calculateAndSaveChecksumPbcKey(pvtKey: string): void {
    const checksumKey = this.prepareToCryptoService.checkSum(null, pvtKey);
    const keyDueDate = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString();
    this.storageService.set(`${environment.jwe.pub}`, pvtKey, true, keyDueDate);
    this.storageService.set(`${environment.jwe.csprvt}`, checksumKey, true, keyDueDate);
  }

  public onLogout() {
    sessionStorage.removeItem(environment.keyStorage.userEscrow);
    sessionStorage.removeItem(environment.keyStorage.menu);
    let redirectUrl = document.location.protocol + '//' + document.location.hostname;

    if (document.location.hostname.includes('localhost')) {
      redirectUrl += ':' + document.location.port;
    }
    this.userInfoService.onLogout(redirectUrl);
  }
}
